import React from 'react';
import { FileTextIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { kordisTrustPatterns } from '../../data/kordis';
const CONFIDENCE = ['High', 'Moderate', 'Low'];
const OPTIONS = ['US entity', 'Canada entity', 'Both, consolidated'];
export function TrustPatterns() {
  const visuals = [<div key="cite" className="w-full max-w-[220px] space-y-2" data-id="element-626" data-mp="3isff4bcimmpn">
      <p className="text-xs leading-6 text-fg" data-id="element-627" data-mp="2v1t9srtwbgjc">
        Freight rose 31%
        <span className="mx-1 inline-grid h-5 min-w-[20px] place-items-center rounded-md bg-ink px-1 align-[1px] text-[11px] font-semibold text-white" data-id="element-628" data-mp="2uzp72d7qgnkn">
          2
        </span>
      </p>
      <div className="ml-6 h-4 w-px bg-ink/30" data-id="element-629" data-mp="34sxl9hkd4j9f" />
      <div className="flex items-center gap-2 rounded-lg bg-white p-2.5 shadow-sm ring-1 ring-ink/15" data-id="element-630" data-mp="300cvqs8hosbp">
        <FileTextIcon className="h-4 w-4 text-ink" data-id="element-631" data-mp="2casdkbk5tz3h" />
        <div data-id="element-632" data-mp="2c97gae6go21x">
          <p className="text-[11px] font-medium text-fg" data-id="element-633" data-mp="2c8z4yqpzl4su">Carrier contract.pdf</p>
          <p className="text-[10px] text-fg-faint" data-id="element-634" data-mp="27a4ldmk73c7o">Page 4 · Mar 3</p>
        </div>
      </div>
    </div>, <div key="conf" className="w-full max-w-[220px] rounded-lg bg-white p-3 shadow-sm" data-id="element-635" data-mp="3p0un6dc535rs">
      <p className="text-[11px] font-medium text-fg-muted" data-id="element-636" data-mp="3t2pq1m9pxr7o">How sure is Kordis?</p>
      <ul className="mt-2 space-y-1" data-id="element-637" data-mp="1r62v6wiev6e">
        {CONFIDENCE.map(level => <li key={level} className={`rounded-md px-2 py-1.5 text-[11px] ${level === 'Moderate' ? 'bg-coral-soft font-semibold text-rust' : 'text-fg-faint'}`} data-id="element-638" data-mp="6p7n3v5o90jg">
            {level}
            {level === 'Moderate' && <span className="font-normal" data-id="element-639" data-mp="3f4rcgj381yt8"> · invoices still syncing</span>}
          </li>)}
      </ul>
    </div>, <div key="ask" className="w-full max-w-[220px]" data-id="element-640" data-mp="3k4dr8wyp7n45">
      <div className="rounded-xl rounded-bl-sm bg-white px-3 py-2 text-[11px] text-fg shadow-sm" data-id="element-641" data-mp="3k1rhqrs8yxja">
        Which Northwind entity should I use?
      </div>
      <div className="mt-2 flex flex-wrap gap-1.5" data-id="element-642" data-mp="zcu0tw8m5lk1">
        {OPTIONS.map(o => <span key={o} className="rounded-full border border-ink/25 bg-white px-2 py-1 text-[10px] font-medium text-ink" data-id="element-643" data-mp="9oyc2ojcggd0">
            {o}
          </span>)}
      </div>
    </div>];
  return <div className="grid gap-6 md:grid-cols-3 md:gap-4" data-id="element-644" data-mp="jo70l1vfx2rz">
      {kordisTrustPatterns.map((pattern, i) => <Reveal key={pattern.title} delay={i * 0.05} data-id="element-645" data-mp="eoavt0ex57bd" data-mpi={i}>
          <figure data-id="element-646" data-mp="emq5jmzn0ajb">
            <div aria-hidden className="grid aspect-[4/3] place-items-center rounded-2xl bg-surface p-5" data-id="element-647" data-mp="3n44enlwq2uvl">
              {visuals[i]}
            </div>
            <figcaption className="mt-3" data-id="element-648" data-mp="3i6uizoiqpmzb">
              <span className="block text-sm font-semibold text-fg" data-id="element-649" data-mp="ojdwola76s3">{pattern.title}</span>
              <span className="mt-1 block text-sm text-fg-muted" data-id="element-650" data-mp="3s3h0q4frrxx4">{pattern.body}</span>
            </figcaption>
          </figure>
        </Reveal>)}
    </div>;
}